import { Injectable } from "@angular/core";
import { BehaviorSubject, Observable, Subject } from "rxjs";
import { tap } from "rxjs/operators";
import { PaymentAcquirerSort, PaymentAcquirerUpdateSortSequence } from "src/app/core/models/payment-acquirer-model/payment-acquirer-sort.model";
import { PaymentAcquirerReferenceService } from "src/app/core/services/system-services/payment-acquirer-reference.service";

@Injectable({
    providedIn: 'root'
})
export class PaymentAcquirerSortService {

    private _paymentAcquirers$ = new BehaviorSubject<PaymentAcquirerSort[]>([])
    private _callSort$ = new BehaviorSubject<boolean>(false)
    private _refresh$ = new Subject()
    private _updateSort$ = new Subject()

    get paymentAcquirers$() {
        return this._paymentAcquirers$.asObservable()
    }
    get callSort$() {
        return this._callSort$.asObservable()
    }
    get refresh$() {
        return this._refresh$.asObservable()
    }
    get updateSort$() {
        return this._updateSort$.asObservable()
    }

    constructor(private paymentAcquirerReference: PaymentAcquirerReferenceService
    ) {
    }

    getPaymentAcquirersSort(): Observable<PaymentAcquirerSort[]> {
        return this.paymentAcquirerReference.getSort()
            .pipe(
                tap(response => this._paymentAcquirers$.next(response))
            )
    }

    updateSortSequence(items: PaymentAcquirerUpdateSortSequence[]): Observable<never> {
        return this.paymentAcquirerReference.updateSortSequence(items)
    }

    clearSort() {
        this._paymentAcquirers$.next([])
    }
    callSort() {
        this._callSort$.next(true)
    }

    refresh() {
        this._refresh$.next()
    }
    updateSort() {
        this._updateSort$.next()
    }
}
